import Modal from "@components/atoms/Modal";
import AuthenticationScreen from "./AuthenticationScreen";
import { useTranslation } from "react-i18next";
import { setLoginModalType } from "@redux/slices/appStateSlice";
import { useDispatch, useSelector } from "react-redux";
import { View } from "react-native";
//import { useNavigation } from "@react-navigation/native";
// import Routes from "@navigations/Routes";
// import { useTheme } from "styled-components/native";

const AuthenticationModal = () => {
  const { t } = useTranslation();
  const loginModalType = useSelector((state) => state.appState.loginModalType);
  // const navigation = useNavigation();
  const dispatch = useDispatch();
  // const theme = useTheme();
  const onClose = async () => {
    // const history = await getSessionHistory();
    // if (
    //   theme.isMobile &&
    //   [Routes.Explore, Routes.ExploreNavigator].includes(
    //     history[history.length - 1]
    //   )
    // ) {
    //   DeviceEventEmitter.emit("RESET_EXPLORE_PAGE_ACTIVE_INDEX");
    // } else if (
    //   loginModalType === "go-back" &&
    //   navigation.canGoBack() &&
    //   history[history.length - 1] === Routes.ExploreNavigator
    // ) {
    //   navigation.goBack();
    // } else {
    //   if (
    //     history.length &&
    //     history.length > 1 &&
    //     history[history.length - 1] !== "pdp-screen"
    //   ) {
    //     const lastNavigatorName = history[history.length - 2];
    //     const navigator = await getNavigatorFromRoute({
    //       route: lastNavigatorName,
    //     });
    //     if (navigator && navigator.name) {
    //       navigateToNavigatorRoute({ navigator });
    //     }
    //   }
    // }
    dispatch(setLoginModalType("none"));
  };

  // const navigateToNavigatorRoute = ({ navigator }: any) => {
  //   if (
  //     navigator?.state &&
  //     navigator.state?.routes &&
  //     navigator.state.routes?.length
  //   ) {
  //     const _navigator =
  //       navigator.state.routes[navigator.state.routes.length - 1];
  //     navigateToNavigatorRoute({ navigator: _navigator });
  //   } else if (navigator?.params && navigator.params?.screen) {
  //     navigate(navigator.name, {
  //       screen: navigator.params.screen,
  //       params: navigator.params.params ?? {},
  //     });
  //   } else if (navigator.name) {
  //     navigate(navigator.name, {
  //       ...(navigator.params ?? {}),
  //     });
  //   }
  // };

  return (
    <Modal
      isOpen={loginModalType !== "none"}
      onClose={onClose}
      headerTitle={t("login.modalTitle.text")}
      transparent={true}
      enableToastMessage={true}
      disableScrollWeb={true}
    >
      <View style={{ padding: 8, paddingBottom: 12 }}>
        <AuthenticationScreen
          renderAsChild
          fromModal={true}
          proceedWithoutLoginFromModalPress={() =>
            dispatch(setLoginModalType("none"))
          }
        />
      </View>
    </Modal>
  );
};

export default AuthenticationModal;
